import React, { useEffect, useRef, useState } from 'react';
import './EmojiPicker.css';

const CATEGORIES = [
  {
    id: 'smileys',
    label: 'Смайлы',
    icon: '😀',
    emojis: ['😀', '😃', '😄', '😁', '😆', '😅', '😂', '🤣', '🙂', '😊', '😇', '🙃', '😉', '😌', '😍', '🥰', '😘', '😋', '😜', '🤪', '🤨', '🧐', '🤓', '😎', '🥳', '🤩', '😐', '😶', '😏', '😒', '🙄', '😔', '😟', '🙁', '😣', '😫', '🥺', '😢', '😭', '😤', '😠', '🤬', '🤯', '😳', '😱', '😨', '😰', '🤗', '🤔', '🤭', '🤫', '😴', '🤤', '🥴', '🤢', '🤧', '😷', '🤒', '🤕'],
  },
  {
    id: 'gestures',
    label: 'Жесты',
    icon: '👍',
    emojis: ['👍', '👎', '👌', '✌️', '🤞', '🤟', '🤘', '🤙', '👈', '👉', '👆', '👇', '☝️', '✋', '🤚', '🖐️', '👋', '🤝', '👏', '🙌', '🙏', '💪', '🫶', '🤲'],
  },
  {
    id: 'hearts',
    label: 'Сердца',
    icon: '❤️',
    emojis: ['❤️', '🧡', '💛', '💚', '💙', '💜', '🤎', '🖤', '🤍', '💔', '❤️‍🔥', '💕', '💞', '💓', '💗', '💖', '💘', '💝', '✨', '🌟', '⭐'],
  },
  {
    id: 'animals',
    label: 'Животные',
    icon: '🐾',
    emojis: ['🐶', '🐱', '🐭', '🐹', '🐰', '🦊', '🐻', '🐼', '🐨', '🐯', '🦁', '🐮', '🐷', '🐸', '🐵', '🐔', '🐧', '🐦', '🐤', '🦆', '🦅', '🐺', '🐴', '🦄', '🐝', '🦋', '🐌', '🐞', '🐢', '🐍', '🦎', '🐙', '🦐', '🐟', '🐬', '🐳', '🐊', '🐅', '🐆', '🐘', '🦒', '🐪', '🐐', '🐑', '🐖', '🐓', '🕊️', '🐾', '🦴'],
  },
  {
    id: 'medical',
    label: 'Медицина',
    icon: '💊',
    emojis: ['💊', '💉', '🩺', '🩹', '🌡️', '🏥', '🩸', '🧬', '🔬', '🧫', '⚕️', '🆘', '📋', '📝', '📌', '📎', '✅', '❌', '❗', '❓', '💯', '⚠️', '🔔'],
  },
  {
    id: 'misc',
    label: 'Разное',
    icon: '🎉',
    emojis: ['🎉', '🎊', '🎁', '🍎', '🍊', '🍌', '🍓', '🍒', '🥕', '🌽', '🥛', '☕', '🍵', '🍼', '🏠', '🚗', '📞', '💬', '💡', '☀️', '🌙', '⏰', '📅', '💰', '🎈', '🌸', '🌹', '🌻', '🌳', '🌲'],
  },
];

export default function EmojiPicker({ onSelect, onClose, anchorRef }) {
  const [activeCat, setActiveCat] = useState('smileys');
  const popoverRef = useRef(null);

  useEffect(() => {
    const handleDown = (e) => {
      if (!popoverRef.current) return;
      if (popoverRef.current.contains(e.target)) return;
      if (anchorRef?.current && anchorRef.current.contains(e.target)) return;
      onClose?.();
    };
    const handleKey = (e) => {
      if (e.key === 'Escape') onClose?.();
    };
    document.addEventListener('mousedown', handleDown);
    document.addEventListener('keydown', handleKey);
    return () => {
      document.removeEventListener('mousedown', handleDown);
      document.removeEventListener('keydown', handleKey);
    };
  }, [onClose, anchorRef]);

  const active = CATEGORIES.find((c) => c.id === activeCat) ?? CATEGORIES[0];

  return (
    <div className="emoji-picker" ref={popoverRef} role="dialog" aria-label="Выбор эмодзи">
      <div className="emoji-picker__tabs">
        {CATEGORIES.map((c) => (
          <button
            key={c.id}
            type="button"
            className={'emoji-picker__tab' + (c.id === activeCat ? ' is-active' : '')}
            onMouseDown={(ev) => ev.preventDefault()}
            onClick={() => setActiveCat(c.id)}
            aria-label={c.label}
            title={c.label}
          >
            {c.icon}
          </button>
        ))}
      </div>
      <div className="emoji-picker__grid">
        {active.emojis.map((e, idx) => (
          <button
            key={active.id + idx}
            type="button"
            className="emoji-picker__item"
            onMouseDown={(ev) => ev.preventDefault()}
            onClick={() => onSelect?.(e)}
          >
            {e}
          </button>
        ))}
      </div>
    </div>
  );
}
